import { cva } from 'class-variance-authority';

export const buttonVariants = cva(
  [
    'inline-flex gap-2 items-center justify-start whitespace-nowrap rounded-md ring-offset-white transition-colors font-medium',
    'hover:no-underline',
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2',
    'disabled:pointer-events-none disabled:opacity-25',
  ],
  {
    variants: {
      size: {
        default: 'h-10 px-4',
        xs: 'h-6 px-2 text-sm',
        sm: 'h-9 px-3',
        lg: 'h-11 px-8',
        icon: 'h-10 w-10',
      },
      variant: {
        'default': ['bg-indigo-500 text-white', 'not-disabled:hover:bg-indigo-600'],
        'destructive': ['bg-red-500 border border-red-500 text-white', 'not-disabled:hover:bg-red-500'],
        'success': ['bg-green-500 border border-green-500 text-white', 'not-disabled:hover:bg-green-500'],
        'outline': ['border border-indigo-500 text-indigo-500', 'not-disabled:hover:bg-indigo-50'],
        'outline-destructive': ['border border-red-500 text-red-500', 'not-disabled:hover:bg-red-50'],
        'outline-success': ['border border-green-500 text-green-500', 'not-disabled:hover:bg-green-50'],
        'ghost': ['not-disabled:hover:bg-slate-100 not-disabled:hover:text-slate-900'],
        'link': ['underline-offset-4', 'not-disabled:hover:underline'],
      },
    },
    defaultVariants: {
      size: 'default',
      variant: 'default',
    },
  }
);
